module.exports = __webpack_public_path__ + "img/yingyezhizhao.3b095048.webp";